module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-rojo.a2f6c78d.svg";